import { useCallback } from 'react';
import useCheckoutState from './useCheckoutState';

const NO_ATTRIBUTES = {};

// Only the dashboard's in-page preview sets previewDeviceSize, so the live store, the
// test-payments iframe and the embed measurer render exactly the markup they always did.
export default function useAiTarget() {
  const { isPreview, previewDeviceSize } = useCheckoutState();
  const isEditorPreview = Boolean(isPreview && previewDeviceSize);

  return useCallback(
    (target, extra) => (isEditorPreview ? { 'data-ai-target': target, ...extra } : NO_ATTRIBUTES),
    [isEditorPreview],
  );
}
